module.exports = __webpack_public_path__ + "media/images/proof_links/proof_green/twitter_big-70b7801b3872bf9bfaaba6e10177270b.svg";